export default "__VITE_ASSET__7aefd2b1__"